export default __webpack_public_path__ + "static/media/wP.589a984c.svg";